import { LoyaltyProductsGridView } from '~/components/loyalty/products';
import { PageContainer } from '~/components/page-container';

export function LoyaltyProducts() {
	return (
		<PageContainer>
			<LoyaltyProductsGridView />
		</PageContainer>
	);
}
